/** @file Pixels per world unit of a camera (square root of its linear part's absolute determinant). */
import type { Camera } from '@pose2d/geometry/types';

/** Uniform zoom of `camera.worldToPixel` (fitCamera cameras: exactly their scale). */
export function pixelsPerUnit(camera: Camera): number {
  const m = camera.worldToPixel;
  return Math.sqrt(Math.abs((m[0] ?? 0) * (m[3] ?? 0) - (m[1] ?? 0) * (m[2] ?? 0)));
}
